import { useCallback, useState } from "react";
import { FileWithPath, useDropzone } from "react-dropzone";
import clsx from "clsx";
import { DropFileIcon } from "@/shared/icons";
import { Button, Icon, Modal, Select, SelectOption, TextInput } from "@/shared/ui";
import AccountCharSupportTrigger from "@/domains/account/components/char/support/AccountCharSupportTrigger.tsx";

export default function AccountCharSupportContainer() {
  const onDrop = useCallback((acceptedFiles: FileWithPath[]) => {
    const formData = new FormData();
    acceptedFiles.forEach((file) => {
      formData.append("files", file);
    });

    console.log({ formData });
  }, []);

  const { acceptedFiles, getRootProps, getInputProps } = useDropzone({
    accept: {
      "image/*": [".jpg", ".jpeg", ".png"],
    },
    maxFiles: 3,
    maxSize: 5 * 1024 * 1024, // 5 MB
    onDrop,
  });
  const [showModal, setShowModal] = useState(false);
  const [message, setMessage] = useState("");

  const openModal = useCallback(() => {
    setShowModal(true);
  }, []);

  const closeModal = useCallback(() => {
    setShowModal(false);
  }, []);

  const footer = <Button>Отправить</Button>;

  return (
    <>
      <AccountCharSupportTrigger onClick={openModal} />
      {showModal && (
        <Modal open onClose={closeModal} className="w-[27.5rem] min-h-[28rem]" footer={footer}>
          <div className="flex flex-col w-full">
            <div className="text-white text-16 font-bold w-full text-center">
              Форма обратной связи
            </div>
            <div className="flex flex-col gap-2.5 mt-5">
              <div className="text-white text-16 font-medium">Тема:</div>
              <Select placeholder="Выберите тему" className="z-1">
                <div className="flex flex-col">
                  <SelectOption onClick={() => {}} isSelected>
                    Не удаляется персонаж
                  </SelectOption>
                  <SelectOption onClick={() => {}}>Пропали деньги</SelectOption>
                  <SelectOption onClick={() => {}}>Заблокировали персонажа</SelectOption>
                </div>
              </Select>
            </div>
            <div className="flex flex-col gap-2.5 mt-3.5">
              <div className="text-white text-16 font-medium">Текст обращения:</div>
              <TextInput
                placeholder="Введите текст вашего обращения..."
                onChange={setMessage}
                value={message}
              />
            </div>
            <div
              {...getRootProps({
                className: clsx(
                  "dropzone flex items-center justify-between px-5 py-3.5 bg-gradient-to-r from-accent-solid/30 to-accent-solid/10",
                  "border-accent-solid border rounded-[0.5rem] mt-3.5 pointer",
                ),
              })}
            >
              <input {...getInputProps()} />
              <div className="text-14 font-medium text-white">
                Прикрепить файл{" "}
                <span className="text-white/50 text-12 font-medium">[PNG, JPG, JPEG]</span>
              </div>
              <DropFileIcon size={20} />
            </div>

            <ul>
              {acceptedFiles.map((file) => (
                <li key={file.name}>
                  {file.name} - {file.size} bytes
                </li>
              ))}
            </ul>
          </div>
        </Modal>
      )}
    </>
  );
}
